module.exports = __webpack_public_path__ + "static/media/5-min-dr@3x.7db9b28b.png";